import { BaseElement } from './base-element';
import { ConditionComparisonType } from './condition-comparison.enum';
import { ConditionRenderType } from './condition-render.enum';
import { ElementType } from './element-type';

export class Condition extends BaseElement {
  value: any;
  target: string;
  comparison: ConditionComparisonType;
  render: ConditionRenderType;

  constructor(target: string, value: any, comparison: ConditionComparisonType, render: ConditionRenderType) {
    super();
    this.elementType = ElementType.container;
    this.target = target;
    this.value = value;
    this.comparison = comparison;
    this.render = render;
  }
}
